import React, { Component } from 'react';
import { isMobile } from 'react-device-detect';
import PropTypes from 'prop-types';

import cable from '../cable';
import MessagesConnectionDetails from './MessagesConnectionDetails';
import MessagesConnectionItem from './MessagesConnectionItem';
import Spinner from './Spinner';
import { SearchIcon } from './Icon';
import Dropdown from './Dropdown';
import Avatar from './Avatar';

export default class MessagesConnectionList extends Component {
  static propTypes = {
    connectionsApi: PropTypes.string.isRequired,
    connectionReadApi: PropTypes.string.isRequired,
    selectedConnectionListId: PropTypes.string,
    selectedConnectionId: PropTypes.string,
    currentUser: PropTypes.object.isRequired,
    searchUrl: PropTypes.string.isRequired,
    onRead: PropTypes.func.isRequired,
    startConnection: PropTypes.object,
    helpLink: PropTypes.string.isRequired,
    closeModal: PropTypes.func.isRequired,
  };

  static defaultProps = {
    selectedConnectionListId: null,
    selectedConnectionId: null,
    startConnection: null,
  };

  constructor(props) {
    super(props);

    Union.log('Initial selected connection id:', props.selectedConnectionId);

    this.state = {
      connections: [],
      loading: true,
      selectedConnectionId: props.selectedConnectionId,
      startConnection: props.startConnection,
    };
  }

  handleClick = (selectedConnectionId) => {
    this.setState({ selectedConnectionId });
    this.markAsRead(selectedConnectionId);
  };

  handleNewMessage = () => {
    this.fetchConnections(this.props.selectedConnectionListId, false);
  };

  handleNewConnection = (connectionId) => {
    Union.log('A new connection was created. Selecting it...', connectionId);
    this.fetchConnections(this.props.selectedConnectionListId, false, () => {
      Union.log('A new connection was created - List and state updated...');
      this.setState({ selectedConnectionId: connectionId, startConnection: null });
    });
  };

  handleBackClick = () => {
    if (this.state.selectedConnectionId) {
      this.setState({ selectedConnectionId: null });
    } else {
      this.props.closeModal();
    }
  };

  markAsRead = (selectedConnectionId) => {
    const { connections } = this.state;
    const connectionIndex = connections.findIndex((c) => c.id === selectedConnectionId);
    const connection = connections[connectionIndex];

    if (this.connectionIsUnread(connection)) {
      Union.log('An unread connection was selected');
      this.props.onRead(connection.id);

      $.post(this.props.connectionReadApi.replace(':connection_id', connection.id), () => {
        // Update the connection without mutating state
        this.setState({
          connections: [
            ...connections.slice(0, connectionIndex),
            { ...connection, unread: null },
            ...connections.slice(connectionIndex + 1),
          ],
        });

        Union.log('Unread connection marked as read');
      });
    }
  };

  fetchConnections(communitySlug, loading = true, afterFetchConnectionsCallback = () => {}) {
    this.setState({ loading });

    $.get(this.props.connectionsApi, { community_slug: communitySlug }, (response) => {
      const connections = response.sort(
        (a, b) =>
          new Date(b.last_message && b.last_message.created_at) -
          new Date(a.last_message && a.last_message.created_at)
      );
      let { selectedConnectionId } = this.state;
      const { startConnection } = this.state;

      if (!selectedConnectionId && !startConnection && connections.length > 0) {
        selectedConnectionId = connections[0].id;
      }

      this.setState(
        {
          loading: false,
          selectedConnectionId: isMobile ? null : selectedConnectionId,
          connections,
        },
        afterFetchConnectionsCallback
      );
    });
  }

  componentWillUpdate(nextProps) {
    if (nextProps.selectedConnectionListId !== this.props.selectedConnectionListId) {
      this.fetchConnections(nextProps.selectedConnectionListId, true);
    }
  }

  componentDidMount() {
    this.fetchConnections(this.props.selectedConnectionListId, true);
    this.subscribe();
  }

  componentWillUnmount() {
    this.unsubscribe();
  }

  subscribe() {
    Union.log('List is subscribing to new connections');

    this.subscription = cable.subscriptions.create(
      {
        channel: 'ConnectionsChannel',
        user_id: this.props.currentUser.id,
      },
      {
        received: (data) => {
          Union.log('New connection received:', data);
          this.fetchConnections(this.props.selectedConnectionListId, false);
        },
      }
    );

    this.subscription = cable.subscriptions.create(
      {
        channel: 'MessagesChannel',
        user_id: this.props.currentUser.id,
      },
      {
        received: (data) => {
          Union.log('New message received:', data);
          this.fetchConnections(this.props.selectedConnectionListId, false);
        },
      }
    );
  }

  unsubscribe() {
    if (this.subscription) {
      Union.log('List is unsubscribing to new connections');
      this.subscription.unsubscribe();
    }
  }
  connectionIsUnread(connection) {
    if (!connection) return;

    const userSide = connection.author.id === this.props.currentUser.id ? 'author' : 'recipient';
    return connection.unread === userSide;
  }

  renderBlankSlate() {
    return (
      <div
        className={`u-px-4 u-h-24 md:u-px-3 md:u-h-22 u-flex u-items-center u-border-b u-bg-white u-border-grey-lighter u-text-grey-darker`}>
        <div className="u-w-full">
          <div className="u-flex u-justify-between">
            <div className="u-uppercase u-text-xs">Search</div>
            {this.renderMessageStaff()}
          </div>
          <div className="u-mt-2 u-mb-0 u-mx-auto">
            <form action={this.props.searchUrl} className="search u-h-8 u-flex">
              <input
                type="search"
                name="query"
                className="search-input messages-search-input u-bg-transparent u-text-sm u-flex-1"
                placeholder="Find people to connect with"
              />
              <button className="search-button md:u-hidden u-ml-2 u-opacity-50">
                <SearchIcon width="16" />
              </button>
            </form>
          </div>
        </div>
      </div>
    );
  }

  renderMessageStaff() {
    return (
      <a href={this.props.helpLink} className="u-text-xs">
        Help Center
      </a>
    );
  }

  renderConnection = (connection) => (
    <MessagesConnectionItem
      key={connection.id || 'new'}
      connection={connection}
      currentUser={this.props.currentUser}
      selected={!isMobile && this.state.selectedConnectionId === connection.id}
      unread={this.connectionIsUnread(connection)}
      onClick={this.handleClick}
      onNewMessage={this.handleNewMessage}
    />
  );

  renderConnections() {
    return this.state.connections.map(this.renderConnection);
  }

  renderHeader(selectedUser) {
    return (
      <div className="u-px-4 lg:u-h-22 u-flex u-items-center lg:u-border-b lg:u-border-grey-lighter">
        <Avatar
          src={selectedUser.avatar_url}
          className="u-w-8 u-h-8 lg:u-w-12 lg:u-h-12 u-flex-none u-mr-3"
          type="user"
          name={selectedUser.full_name}
        />
        <div className="u-hidden u-flex-col lg:u-flex">
          <a href={selectedUser.profile_path} className="u-text-md u-font-semibold">
            {selectedUser.full_name}
          </a>
          <div
            dangerouslySetInnerHTML={{ __html: selectedUser.job_title_with_link }}
            className="u-text-xs u-font-semibold"></div>
        </div>
        <div className="u-block lg:u-hidden">
          <span className="u-text-old-even-darker-grey">{selectedUser.full_name}</span>
        </div>
      </div>
    );
  }

  renderDropdownTrigger() {
    return <i className="Icon_v2 Icon-more u-flex u-color-white u-items-center u-p-4" />;
  }

  render() {
    const { selectedConnectionId, startConnection, loading, connections } = this.state;
    const selectedConnection =
      this.state.connections.filter((c) => c.id === this.state.selectedConnectionId)[0] ||
      this.props.startConnection;
    let selectedUser = null;

    if (selectedConnection) {
      selectedUser =
        selectedConnection.recipient.id === this.props.currentUser.id
          ? selectedConnection.author
          : selectedConnection.recipient;
    }

    return (
      <div className="u-flex-1 u-flex u-flex-row u-relative u-pt-12 lg:u-pt-0 u-mt-0">
        {isMobile && (
          <div className="topbar topbar--community u-flex u-justify-center u-text-old-even-darker-grey u-items-center u-text-lg">
            <i
              className="Icon Icon-arrow-backward u-absolute u-px-4 u-py-3 u-left-0 u-z-10"
              onClick={this.handleBackClick}
            />
            {!selectedUser && <span>Messages</span>}
            {(connections.length > 0 || startConnection) && selectedUser && (
              <div className="u-relative u-flex u-flex-1 u-justify-center">
                {this.renderHeader(selectedUser)}
                <div className="u-fixed u-right-0 u-top-0">
                  <Dropdown
                    contentClassName="u-mr-2 u-right-0 u-z-10"
                    listClassName="u-text-old-primary-color u-text-sm"
                    triggerClassName="hover:u-text-white u-text-white"
                    renderTrigger={this.renderDropdownTrigger}
                    addMarginTop={false}
                    items={[
                      {
                        key: 'view-profile',
                        href: selectedUser.profile_path,
                        text: 'View Profile',
                      },
                      {
                        key: 'help-center',
                        href: this.props.helpLink,
                        text: 'Help center',
                      },
                    ]}
                  />
                </div>
              </div>
            )}
          </div>
        )}
        {(!isMobile || !selectedUser) && (
          <div className="u-border-r u-border-grey-lighter u-bg-grey-lightest u-w-full lg:u-w-64 lg:u-flex-none u-max-w-full">
            {!loading && this.renderBlankSlate()}
            {loading && (
              <div className="u-p-6 u-text-grey u-leading-none">
                <Spinner />
              </div>
            )}
            {!loading && startConnection && this.renderConnection(startConnection)}
            <div className="u-flex-1 u-overflow-auto" style={{ height: 'calc(100% - 5.5rem)' }}>
              {this.renderConnections()}
            </div>
          </div>
        )}

        {(connections.length > 0 || startConnection) && (!isMobile || (isMobile && selectedUser)) && (
          <div className="u-w-full">
            {!isMobile && selectedUser && this.renderHeader(selectedUser)}
            <MessagesConnectionDetails
              {...this.props}
              selectedConnectionId={selectedConnectionId}
              startConnection={startConnection}
              onNewConnection={this.handleNewConnection}
              markAsRead={this.markAsRead}
            />
          </div>
        )}
      </div>
    );
  }
}
